import { MenuItems } from "./MenuItems";

export const adminMenuItems: MenuItems[] = [
  // ── Overview ──────────────────────────────────────────────
  {
    label: "Dashboard",
    path: "/admin",
    icon: "pi pi-home",
    section: "Overview",
    allowedRoles: ["ADMIN", "SUPERADMIN", "REVIEWER"],
  },

  // ── Users & KYC ───────────────────────────────────────────
  {
    label: "Users",
    path: "/admin/users",
    icon: "pi pi-user",
    section: "Users & KYC",
    requiredPermission: "US003",
  },
  {
    label: "Customers",
    path: "/admin/customers",
    icon: "pi pi-users",
    section: "Users & KYC",
    requiredPermission: "CU001",
  },
  {
    label: "User Roles",
    path: "/admin/manage-roles",
    icon: "pi pi-id-card",
    section: "Users & KYC",
    requiredPermission: "RO001",
  },
  {
    label: "Documents Type",
    path: "/admin/manage-document",
    icon: "pi pi-file",
    section: "Users & KYC",
    requiredPermission: "DO001",
  },

  // ── Transactions ──────────────────────────────────────────
  {
    label: "Transactions history",
    path: "/admin/transaction-history",
    icon: "pi pi-history",
    section: "Transactions",
    requiredPermission: "PY010",
  },
  {
    label: "Transactions log",
    path: "/admin/transaction-log",
    icon: "pi pi-align-justify",
    section: "Transactions",
    requiredPermission: "TL001",
  },
  {
    label: "Payment Link",
    path: "/admin/payment-link",
    icon: "pi pi-link",
    section: "Transactions",
    requiredPermission: "PY006",
  },
  {
    label: "Payout",
    path: "/admin/payout",
    icon: "pi pi-send",
    section: "Transactions",
    requiredPermission: "PO001",
  },

  // ── Finance ───────────────────────────────────────────────
  {
    label: "Withdrawals",
    path: "/admin/manage-withdrawals",
    icon: "pi pi-credit-card",
    section: "Finance",
    requiredPermission: "WI002",
  },
  {
    label: "Reconciliation",
    path: "/admin/reconciliation",
    icon: "pi pi-calculator",
    section: "Finance",
    requiredPermission: "RC003",
  },

  // ── Configuration ─────────────────────────────────────────
  {
    label: "Services",
    path: "/admin/manage-service",
    icon: "pi pi-th-large",
    section: "Configuration",
    requiredPermission: "SE002",
  },
  {
    label: "Partners",
    path: "/admin/partners",
    icon: "pi pi-building",
    section: "Configuration",
    requiredPermission: "PA002",
  },
  {
    label: "Monetary zones",
    path: "/admin/manage-monetary-zone",
    icon: "pi pi-chart-pie",
    section: "Configuration",
    requiredPermission: "MO002",
  },
  {
    label: "Countries",
    path: "/admin/countries-monetary-zone",
    icon: "pi pi-globe",
    section: "Configuration",
    requiredPermission: "CO002",
  },
  {
    label: "Route Config",
    path: "/admin/route-config",
    icon: "pi pi-sitemap",
    section: "Configuration",
    requiredPermission: "SR002",
  },
  {
    label: "IP Address",
    path: "/admin/manage-ip-address",
    icon: "pi pi-server",
    section: "Configuration",
    requiredPermission: "IP004",
  },
  {
    label: "Webhooks",
    path: "/admin/webhooks",
    icon: "pi pi-share-alt",
    section: "Configuration",
    requiredPermission: "WH001",
  },

  // ── System ────────────────────────────────────────────────
  {
    label: "Maintenance",
    path: "/admin/maintenance",
    icon: "pi pi-exclamation-circle",
    section: "System",
    allowedRoles: ["ADMIN", "SUPERADMIN"],
  },
  {
    label: "Audit Logs",
    path: "/admin/audit-logs",
    icon: "pi pi-shield",
    section: "System",
    requiredPermission: "AU001",
  },
  {
    label: "Notifications",
    path: "/admin/notifications",
    icon: "pi pi-bell",
    section: "System",
    requiredPermission: "NO002",
  },
];
